<script lang="ts">
    import Checkbox from '@smui/checkbox';
    import { _ } from 'svelte-i18n';
    import ExpandIcon from '../../../../../shared/components/common/Icons/ExpandIcon.svelte';
    import Area from '../../../../../shared/models/Area/Area';
    import { hasRoleSysAdmin } from '../../../../../shared/stores';

    export let data;  
    
    let [dataAree, loadingAree, errorAree] = Area.getList();

    let showRow = {};

    function toggleRow(rowId) {
        showRow[rowId] = !showRow[rowId];
    }
</script>

<div class="flex flex-col">
    <div class="sm:-mx-6 lg:-mx-8 -my-2 overflow-x-auto">
        <div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
            <div class="overflow-hidden">
                <table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
                    <thead>
                        <tr class="p-1">
                            <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"></th>
                            <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                {$_('page.company/entity.list.name')}
                            </th>
                            {#if $hasRoleSysAdmin}
                                <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                    {$_('page.company/entity.list.area')}
                                </th>
                            {/if}
                            <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                {$_('page.company/entity.list.province')}
                            </th>
                            <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                {$_('page.company/entity.list.city')}
                            </th>
                            <th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                {$_('page.company/entity.list.address')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {#if $data?.response}
                            {#each $data?.response as row, i}
                                <tr class="odd:bg-white even:bg-gray-50 hover:bg-gray-50 p-1">
                                    <td class="border-b p-2.5 text-center text-xs leading-6 tracking-wider">
                                        <ExpandIcon condition={showRow[row.id]} onClick="{() => toggleRow(row?.id)}"/>
                                    </td>
                                    <td class="border-b p-2.5 text-center leading-5">{row.nomeAziendaEnte ?? ''}</td>
                                    {#if $hasRoleSysAdmin}
                                        <td class="border-b p-2.5 text-center leading-5">
                                            {row.areaId && !$loadingAree ? $dataAree?.response?.find((x) => x.id === row.areaId)?.nomeComune ?? '' : ''}
                                        </td>
                                    {/if}
                                    <td class="border-b p-2.5 text-center leading-5">{row.provincia ?? ''}</td>
                                    <td class="border-b p-2.5 text-center leading-5">{row.citta ?? ''}</td>
                                    <td class="border-b p-2.5 text-center leading-5">{row.indirizzo ?? ''}
                                        {#if row.provincia && row.citta && row.cap && row.indirizzoOK}
                                            <span
                                                title="{$_('page.company/entity.list.valid_address')}"
                                                class="material-icons-outlined"
                                                style="color: green; font-size: 20px;">fmd_good</span
                                            >
                                        {:else}
                                            <span
                                                title="{$_('page.company/entity.list.not_valid_address')}"
                                                class="material-icons-outlined"
                                                style="color: red; font-size: 20px;">wrong_location</span
                                            >{/if}</td
                                    >
                                    <td class="leading-5 text-center border">
                                        <Checkbox 
                                            checked="{row?.sedi?.some((value) => value.selected === true)}" 
                                            on:change="{(e) => { row?.sedi?.forEach((sede) => (sede.selected = e.target.checked)); row.selected = e.target.checked; row = row }}"
                                        />
                                    </td>
                                </tr>
                                {#if showRow[row?.id]}
                                    <tr id="{row.id}">
                                        <td colspan="6" class="p-4 border">
                                            {#if row?.sedi?.length > 0}
                                                <div class="h-48 overflow-auto">
                                                    <table class="min-w-full p-0 m-0 text-sm leading-10 table-auto">
                                                        <thead>
                                                            <tr class="p-1">
                                                                <th scope="col" class="text-xs leading-6 tracking-wider text-center border">
                                                                    {$_('page.locations.list.denomination')}
                                                                </th>
                                                                <th scope="col" class="text-xs leading-6 tracking-wider text-center border">
                                                                    {$_('page.locations.list.localization')}
                                                                </th>
                                                                <th scope="col" class="text-xs leading-6 tracking-wider text-center border">
                                                                    {$_('page.locations.list.address')}
                                                                </th>
                                                                <th scope="col" class="text-xs leading-6 tracking-wider text-center border"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {#each row.sedi as rowSede}
                                                                <tr class="odd:bg-white even:bg-gray-50">
                                                                    <td class="leading-5 text-center border">{rowSede.denominazione ?? ''}</td>
                                                                    <td class="leading-5 text-center border">{rowSede.localizzazione ?? ''}</td>
                                                                    <td class="leading-5 text-center border"
                                                                        >{rowSede.indirizzo ?? ''}
                                                                        {#if rowSede.provincia && rowSede.citta && rowSede.cap && rowSede.indirizzoOK}
                                                                            <span
                                                                                title="Indirizzo valido"
                                                                                class="material-icons-outlined"
                                                                                style="color: green; font-size: 20px;">fmd_good</span
                                                                            >
                                                                        {:else}
                                                                            <span
                                                                                title="Indirizzo non valido"
                                                                                class="material-icons-outlined"
                                                                                style="color: red; font-size: 20px;">wrong_location</span
                                                                            >
                                                                        {/if}
                                                                    </td>
                                                                    <td class="leading-5 text-center border">
                                                                        <Checkbox
                                                                            checked="{rowSede.selected}"
                                                                            on:click="{() => rowSede.selected = !rowSede.selected}"
                                                                            on:change="{() => { 
                                                                                if (row?.sedi?.some((sede) => sede?.selected === true)) {
                                                                                    row.selected = true;
                                                                                } else {
                                                                                    row.selected = false;
                                                                                }
                                                                            }}"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            {/each}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            {:else}
                                                <span class="w-full p-4">{$_('page.reporting.location.list.no_responding_location')}</span>
                                            {/if}
                                        </td>
                                    </tr>
                                {/if}
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>